<header class="new-home-header" [class.scrolled]="isScrolled">
  <div class="header-container header-width">
    <div class="header-left">
      <button class="menu-toggle" (click)="toggleMenu()" [class.menu-open]="isMenuOpen" aria-label="Open menu">
        <span class="hamburger-line"></span>
        <span class="hamburger-line"></span>
        <span class="hamburger-line"></span>
      </button>
    </div>

    <div class="header-center">
      <a routerLink="/home" class="logo">
        <img src="assets/images/bannerlogo.png" alt="Seychelles" class="logo-image" loading="lazy" decoding="async" />
      </a>
    </div>

    <div class="header-right">
      <div class="weather-widget">
        <div class="weather-content">
          <span class="temperature">{{ temperature }}</span>
          <div class="weather-right">
            <img *ngIf="weatherIcon" [src]="weatherIcon" alt="weather icon" class="weather-icon" />
            <span class="weather-description">{{ translatedWeatherDescription }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</header>
